const config = {
  baseUrl_production: '/xianyu/',
  cdn_production: `//s1.huishoubao.com/hjx/hjx-xystore-h5/dist`
};
module.exports = config;
